<template>
    <div class="card pb-0" v-show="ready">

        <div class="card-header border-0">
            <div class="row">
                <div class="col-12">
                    <h3 class="mb-0 text-uppercase">{{ grid.name }}</h3>
                </div>
            </div>
        </div>

        <p class="card-body pt-2 text-sm" v-if="empty">{{ $t('grids.empty-grid') }}</p>

        <div class="pt-2" v-if="!empty">
            
            <el-table class="table-responsive table-flush"
                    header-row-class-name="thead-light"
                    :data="grid.competencies">

                <el-table-column :label="$t('common.competency')" width="200">
                    <template v-slot="{row}">
                        <h4 class="mb-0">
                            {{ row['name_' + grid.lang] }}
                        </h4>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.description')">
                    <template v-slot="{row}">
                        <small class="description">{{ row.pivot.description }}</small>
                    </template>
                </el-table-column>

                <el-table-column align="right" width="120" class-name="actions" v-if="canEdit">
                    <template v-slot="{row}">
                        <div class="table-actions">

                            <a href="#" class="table-action text-danger" @click.prevent="remove(row)" v-if="canDelete">
                                <i class="tim-icons icon-simple-remove"></i>
                            </a>

                            <a href="#" class="table-action text-primary" @click.prevent="update(row)">
                                <i class="tim-icons icon-pencil"></i>
                            </a>

                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <portal to="modals">

            <form-modal v-model="modals.edit"
                :title="selectedCompetency['name_' + grid.lang]"
            >
                <competency-form v-model="form.data"
                    :errors="form.errors"
                    :modal="modals.edit"
                >
                </competency-form>
            </form-modal>

            <confirm-modal v-model="modals.confirmDelete">
                <p>{{ $t('grids.delete-competency-confirm') }}</p>
            </confirm-modal>

        </portal>

    </div>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'
    import CrudForm from '@trax/classes//CrudForm'
    import GridCompetenciesClient from './GridCompetenciesClient'
    import CompetencyForm from './GridCompetencyForm'

    export default {

        components: {
            CompetencyForm
        },

        props: {
            grid: {
                type: Object,
                required: true
            },
            ready: {
                type: Boolean,
                required: false
            },
        },

        data() {
            let client = new GridCompetenciesClient('/astral/api/front/grids/'+this.$route.params.id+'/competencies')
            return {
                selectedCompetency: {},
                modals: new ModalsController(['edit', 'confirmDelete']),
                form: new CrudForm(client),
                client
            }
        },

        created() {
            this.form.init(this, 'form')
            this.modals.init(this, 'modals')
        },

        computed: {
            
            shared() {
                return this.grid.shared && this.$auth.user.owner_id && this.$auth.user.owner_id != this.grid.owner_id
            },

            canEdit() {
                return !this.shared && this.grid.status != 'archived'
            },
            
            canDelete() {
                return !this.shared && this.grid.status != 'archived' && this.grid.status != 'active'
            },
            
            empty() {
                return !this.grid || !this.grid.competencies || this.grid.competencies.length == 0
            }
        },

        methods: {

            remove(competency) {
                this.modals.open('confirmDelete').then(resp => {
                    if (resp.confirmed) {
                        this.client.delete(competency.id)
                        .then(resp => {
                            this.$emit('change')
                        })
                        .catch(err => {
                            this.$auth.handleErrorVm(err, this)
                        })        
                    }
                })
            },

            update(competency) {
                this.selectedCompetency = competency
                this.modals.open('edit')
                this.form.update({
                    id: competency.id,
                    description: competency.pivot.description,
                    competency_id: competency.pivot.competency_id
                })
                .then(resp => {
                    this.modals.close('edit')
                    this.$emit('change')
                })
            }
        }
    }
</script>

<style scoped>

    .description {
        white-space: pre-wrap;
    }

    .card >>> th,
    .card >>> td {
        padding-right: 0;
    }

    .card >>> th.actions,
    .card >>> td.actions {
        padding-right: 1.5rem;
    }

</style>